module.exports = __webpack_public_path__ + "static/media/gd.f3085728.svg";